import React, { useEffect } from 'react';

const FreshchatWidget = () => {
    useEffect(() => {
        const loadFreshchat = () => {
            const script = document.createElement('script');
            script.src = "https://cdn.freshchat.com/js/widget.js";
            script.async = true;

            script.onload = () => {
                if (window.fcWidget) {
                   
                    window.fcWidget.init({
                        token: "8046a474-71ac-4847-97d7-c5c48c4020e9",
                        host: "https://wchat.freshchat.com"
                    });
                    window.fcWidget.show();
                } else {
                    console.error("Freshchat widget not initialized.");
                }
            };

            script.onerror = () => console.error("Failed to load Freshchat script.");
            document.body.appendChild(script);
        };

        if (!document.querySelector('script[src="https://cdn.freshchat.com/js/widget.js"]')) {
            loadFreshchat();
        }

        return () => {
            const existingScript = document.querySelector('script[src="https://cdn.freshchat.com/js/widget.js"]');
            if (existingScript) {
                document.body.removeChild(existingScript);
            }
        };
    }, []);

    return null; 
};

export default FreshchatWidget;
